import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-configuration',
  imports: [],
  templateUrl: './configuration.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './configuration.css',
})
export class Configuration {}
